import { Table, TableProps } from 'antd';
import styled from 'styled-components';

const NewTable = (props: TableProps<any>) => {
  return (
    <TableStyled>
      <Table {...props} />
    </TableStyled>
  );
};

export default NewTable;
// cell hover background not change, do sth else
const TableStyled = styled.div`
  .ant-table-wrapper .ant-table-tbody > tr.ant-table-row:hover > td {
    background: unset;
  }
  //   .ant-table-tbody .ant-table-row:nth-child(even):hover > td {
  //     // background:rgb(173, 230, 238);
  //   }
  //   .ant-table-tbody .ant-table-row:nth-child(odd):hover > td {
  //     background: rgb(230, 235, 236);
  //   }
  .ant-table-tbody .ant-table-row:nth-child(even) {
    background: #e4f4f6;
  }

  .ant-table-tbody .ant-table-row:nth-child(odd) {
    background: #fff;
  }

  .ant-table-tbody .ant-table-cell {
    color: #1d2129;
    font-family: Poppins;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
  .ant-table-thead .ant-table-cell {
    border-radius: 0 !important;
    border-bottom: 1px solid #ccd4dc;
    background: #6fabb6;
    color: #fff;
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
  }
  .ant-table-thead .ant-table-cell::before {
    height: 100% !important;
    background-color: white !important;
  }
  .ant-table-tbody .ant-table-cell {
    border-right: 1px solid #fff;
    border-bottom: none !important;
    .ellipsis-text {
      text-overflow: ellipsis;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }
`;
